// Qui ouvre la carte nationale (`/sig`) dans le navigateur — CDC G, lot L1. Une seule règle,
// lue par la route (`ProtectedRoute requireCarteNationale`) et par le lien (`LienSig`) :
// un administrateur, ou un compte titulaire du droit « carte nationale » (`carte_nationale` de
// `/auth/me`, lu en base par l'API). Ce n'est qu'un confort d'affichage : l'API revérifie le
// droit à chaque appel (`backend/app/droits_produit.py`), elle ne croit jamais le navigateur.
// Sans module de dépendance (pas d'AuthContext) : les tests qui simulent `useAuth` l'utilisent tel quel.
export function ouvreCarteNationale(
  user: { carte_nationale?: boolean | null } | null | undefined,
  isAdmin: boolean,
): boolean {
  return !!user && (isAdmin || user.carte_nationale === true)
}
